const PREFIX = "cart-savings-footer-strip";

export const CART_SAVINGS_FOOTER_STRIP_TEST_IDS = {
    CONTAINER: `${PREFIX}-container`,
    TEXT: `${PREFIX}-text`,
};
